import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { TagDTO } from '../../../services/api/api';

@Component({
  selector: 'sb-tag-lookups',
  templateUrl: './sb-tag-lookups.component.html',
  styleUrls: ['./sb-tag-lookups.component.scss'],
  standalone: false,
})
export class SbTagLookupsComponent {
  @HostBinding('style.left.px')
  left: number = 0;
  @HostBinding('style.top.px')
  top: number = 0;

  @Input() entries: TagDTO[];
  @Input() searchText: string;
  @Output() itemSelected: EventEmitter<any>;

  constructor() {
    this.itemSelected = new EventEmitter<any>();
  }

  doAutocomplete(e: any | string) {
    this.itemSelected.emit(e);
  }
}
